import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    width: '100%',
    position: 'relative',
  }
}));
